import styled from "styled-components"
import media from "styled-media-query"

export const MainContent = styled.section`
  margin: auto;
  max-width: 100%;
  padding: 2rem 1rem;
  background-color: #f1e8d5;
  border-radius: 0 0 10px 10px;

  ${media.lessThan("medium")`
    max-width: 100%;
  `}
`

export const Section = styled.section`
  color: var(--post);
  margin: 10px;
  padding: 1rem;
  line-height: 1.5;
  border-bottom: 1px solid #dfd2b6;

  ${media.lessThan("medium")`
    padding: 0.2rem 0;
  `}

  p {
    margin: 0 auto 1rem;
    font-size: 1.2rem;
    color: var(--span);
    font-family: "Catamaran", serif;

    ${media.lessThan("medium")`
      font-size: 0.9rem;
    `}
  }

  ul li {
    color: var(--span);
  }
`

export const TitleHome = styled.h2`
  font-size: 1.6rem;
  background-color: #eeadb3;
  border-radius: 55px;
  display: inline-block;
  margin-bottom: 0.8rem;
  font-weight: normal;
  font-family: "Bebas Neue";
  color: #4e3636;
  padding: 0.4rem 1rem 0.2rem;

  ${media.lessThan("small")`
    font-size: 1.2rem;
    padding: 0.4rem 1rem 0.1rem;
  `}

  svg {
    width: 35px;
    position: relative;
    bottom: 2px;
    margin-right: 10px;

    ${media.lessThan("small")`
      width: 20px;
      bottom: 0px;
    `}
  }
`

export const Entry = styled.div`
  margin-bottom: 1.2rem;
`

export const TimelineTitle = styled.div`
  margin-bottom: 0.5em;
  width: 100%;
  position: relative;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--title);
  }

  span {
    margin: 0;
    font-size: 0.8rem !important;
    color: var(--span);

    ${media.lessThan("medium")`
      font-size: 0.6rem !important;
      margin-left: 0.8rem;
  `}
  }

  p {
    display: block;
    /* margin-right: 10rem; */
    font-size: 0.8rem;

    ${media.lessThan("medium")`
      margin-right: 0;
    `}
  }
`

export const Divisor = styled.div`
  width: 100%;
  background: var(--borders);
  height: 1px;
  margin: 10px 0;
`

export const Subtitle = styled.span`
  color: var(--highlight);
  font-size: 1.5rem;
`

export const TechSkills = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
`

export const TechLang = styled.span`
  font-family: sans-serif;
  display: inline-block;
  background-color: ${props => props.color};
  color: #fff;
  border-radius: 4px;
  margin: 6px 4px 4px 0;
  padding: 0.4rem;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  span {
    font-style: italic;
    margin-left: 0;
    margin: 0rem 0 0.6rem;
  }
`

export const AboutGithub = styled.div`
  padding: 1rem 2rem;
  display: flex;

  ${media.lessThan("medium")`
    padding: 0.2rem;
  `}

  .react-github-calendar__title {
    color: var(--maiscor);
  }

  .react-github-calendar__chart {
    color: var(--texts);
  }

  svg.react-github-calendar__calendar text {
    fill: var(--postColor) !important;
  }

  .react-github-calendar {
    margin: 0 auto;
  }
`

export const DescriptionInteresses = styled.p`
  a {
    text-decoration: none;
    color: var(--span);
    box-shadow: inset 0 -4px 0 var(--texts);

    &:hover {
      background-color: var(--texts);
      padding-top: 2px;
      box-shadow: none;
    }
  }
`
